import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';

export default function Header() {
  const { t, toggleLang } = useLanguage();
  const [menuOpen, setMenuOpen] = useState(false);
  const [openSections, setOpenSections] = useState({ products: false, services: false });

  const productItems = t.productItems;
  const serviceItems = t.serviceItems;

  const toggleMenu = () => setMenuOpen(prev => !prev);
  const closeMenu = () => {
    setMenuOpen(false);
    setOpenSections({ products: false, services: false });
  };
  const toggleSection = (key) => setOpenSections(prev => ({ ...prev, [key]: !prev[key] }));

  return (
    <>
      <header className="site-header">
        <div className="nav-inner">
          <Link to="/" className="nav-logo">
            <img src={`${process.env.PUBLIC_URL}/Assets/img/logo.png`} alt="Digicorex Solutions LLC" />
          </Link>
          <nav>
            <ul className="nav-links">
              <li><Link to="/">{t.nav.home}</Link></li>
              <li><Link to="/#about">{t.nav.about}</Link></li>
              <li className="nav-item has-dropdown">
                <Link to="/#products">{t.nav.products}</Link>
                <div className="mega-menu">
                  <div className="mega-column">
                    <h4>{t.nav.products}</h4>
                    {productItems.map(item => (
                      <Link key={item.to} to={item.to}>{item.label}</Link>
                    ))}
                  </div>
                </div>
              </li>
              <li className="nav-item has-dropdown">
                <Link to="/#services">{t.nav.services}</Link>
                <div className="mega-menu">
                  <div className="mega-column">
                    <h4>{t.nav.services}</h4>
                    {serviceItems.map(item => (
                      <Link key={item.to} to={item.to}>{item.label}</Link>
                    ))}
                  </div>
                </div>
              </li>
              <li><Link to="/#industries">{t.nav.industries}</Link></li>
              <li><Link to="/contact" className="nav-cta">{t.nav.contact}</Link></li>
              <li>
                <button type="button" className="lang-switch" onClick={toggleLang}>
                  {t.langToggle}
                </button>
              </li>
            </ul>
          </nav>
          <button className="hamburger" onClick={toggleMenu} aria-label="Menu">
            <span /><span /><span />
          </button>
        </div>
      </header>

      <div className={`mobile-menu${menuOpen ? ' open' : ''}`}>
        <Link to="/" onClick={closeMenu}>{t.nav.home}</Link>
        <Link to="/#about" onClick={closeMenu}>{t.nav.about}</Link>

        <button
          type="button"
          className={`mobile-section-toggle${openSections.products ? ' open' : ''}`}
          onClick={() => toggleSection('products')}
        >
          {t.nav.products}
          <span className="mobile-toggle-arrow">▾</span>
        </button>
        <div className={`mobile-subnav${openSections.products ? ' open' : ''}`}>
          {productItems.map(item => (
            <Link key={item.to} to={item.to} onClick={closeMenu}>{item.label}</Link>
          ))}
        </div>

        <button
          type="button"
          className={`mobile-section-toggle${openSections.services ? ' open' : ''}`}
          onClick={() => toggleSection('services')}
        >
          {t.nav.services}
          <span className="mobile-toggle-arrow">▾</span>
        </button>
        <div className={`mobile-subnav${openSections.services ? ' open' : ''}`}>
          {serviceItems.map(item => (
            <Link key={item.to} to={item.to} onClick={closeMenu}>{item.label}</Link>
          ))}
        </div>

        <Link to="/#industries" onClick={closeMenu}>{t.nav.industries}</Link>
        <Link to="/contact" onClick={closeMenu}>{t.nav.contact}</Link>
        <button type="button" className="lang-switch mobile" onClick={toggleLang}>
          {t.langToggle}
        </button>
      </div>
    </>
  );
}
